export default function (message) {
  return function (props, propname) {
    if (props[propname] !== undefined) {
      return new Error(message);
    }
  }
}